import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Background from '../../components/Background/Background';
import Header from '../../components/Header/Header';
import { planeVariants } from '../../animations/plane';
import fadeIn from '../../animations/fadeIn';
import Logo from '../../components/Logo/Logo';
import { TextField } from '@mui/material';
import Button from '../../components/Button/Button';
import { updatePassword } from '../../api/resetPassword';
import useQuery from '../../hooks/useQuery';
import { useNavigate } from 'react-router-dom';

const ResetPassword = () => {
  const query = useQuery();
  const code = query.get('code') as string;
  const email = query.get('email') as string;
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>();
  const navigate = useNavigate();

  const resetUserPassword = async () => {
    setLoading(true);
    setError(null);
    const data = await updatePassword(code, password, email);
    setLoading(false);
    if (data.success) {
      navigate('/signin');
    } else {
      setError(data.message);
    }
  };

  return (
    <Background image='login-bg'>
      <Header title='Reset Password' />
      <motion.img
        initial='hidden'
        animate='enter'
        exit='exit'
        src='/plane.png'
        className='signin-plane'
        variants={planeVariants}
      />
      <div className='auth-container'>
        <motion.div
          variants={fadeIn(0.5)}
          initial='hidden'
          animate='enter'
          exit='exit'
          className='auth-logo'
        >
          <Logo name='awayz' className='max-w-[100%]' />
        </motion.div>
        <div className='w-full flex flex-col gap-6 items-center'>
          <motion.p
            variants={fadeIn(0.45)}
            initial='hidden'
            animate='enter'
            exit='exit'
            className='w-full text-xl font-semibold'
          >
            Create a new password
          </motion.p>
          <motion.p
            variants={fadeIn(0.3)}
            initial='hidden'
            animate='enter'
            exit='exit'
            className='w-full text-sm'
          >
            Passwords must contain at least 8 characters and a combination of
            upper & lower case letters, numbers, and symbols.
          </motion.p>
          <motion.div
            variants={fadeIn(0.15)}
            initial='hidden'
            animate='enter'
            exit='exit'
            className='w-full'
          >
            <TextField
              id='standard-basic'
              label='New Password'
              variant='standard'
              className='w-full'
              type='password'
              onChange={(e) => setPassword(e.target.value)}
            />
          </motion.div>
          <motion.div
            variants={fadeIn(0.1)}
            initial='hidden'
            animate='enter'
            exit='exit'
            className='w-full'
          >
            <TextField
              id='standard-basic'
              label='Confirm Password'
              variant='standard'
              className='w-full text-white'
              type='password'
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </motion.div>
          {error && <p>{error}</p>}
          <Button
            disabled={password !== confirmPassword || !password}
            delay={0.05}
            onClick={resetUserPassword}
            loading={loading}
          >
            Reset Password
          </Button>
        </div>
      </div>
    </Background>
  );
};

export default ResetPassword;
